export default __webpack_public_path__ + "media/images/plans/girl_1-396d3d160ebe4ad5b9c377802f3d37a1.png";